export function isVisualTestMode(): boolean {
  return process.env.NEXT_PUBLIC_VISUAL_TEST === '1'
}

export function isDevPreviewRoute(pathname: string | null | undefined): boolean {
  return pathname?.includes('/dev/') ?? false
}

export function shouldBypassAppLoader(pathname: string | null | undefined): boolean {
  return isVisualTestMode() || isDevPreviewRoute(pathname)
}
